import { useSyncExternalStore } from "react";

export function useViewportSize() {
  const width = useSyncExternalStore(subscribe, () => window.innerWidth);
  const height = useSyncExternalStore(subscribe, () => window.innerHeight);
  const rem = useSyncExternalStore(subscribe, () =>
    parseFloat(getComputedStyle(document.documentElement).fontSize),
  );
  return { width, height, rem };
}

function subscribe(onChange: () => void) {
  window.addEventListener("resize", onChange);
  return () => window.removeEventListener("resize", onChange);
}
